import React, { useContext } from 'react';
import { SearchStateContext } from 'components/SearchStateProvider';
import { Activities } from 'types/Trails/Activities';
import { Track } from 'types/Trails/Track';
import { Trail } from 'types/Trails/Trail';
import { MapStatsUtil } from 'utils/map_stats_util';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

type Props = {
  currentActivityType?: Activities;
  record: Trail | Track;
  isEstimate?: boolean;
};

const activityTypeToDurationType = (currentActivityType: string) => {
  switch (currentActivityType) {
    case Activities.MOUNTAIN_BIKING:
      return 'duration_minutes_mountain_biking';
    case Activities.ROAD_BIKING:
    case Activities.BIKE_TOURING:
      return 'duration_minutes_cycling';
    case Activities.TRAIL_RUNNING:
      return 'duration_minutes_trail_running';
    case Activities.HIKING:
    case Activities.WALKING:
    case Activities.BACKPACKING:
      return 'duration_minutes_hiking';
  };
};

const CardDuration = ({ record, isEstimate }: Props) => {
  const { filters } = useContext(SearchStateContext);

  const selectedActivity = Object.keys(filters?.activities || {}).find((key: Activities) => filters?.activities[key]?.selected);

  const durationMinutesField = activityTypeToDurationType(selectedActivity);
  const durationMinutes = record[durationMinutesField] || record.duration_minutes;

  if (!durationMinutes) {
    return null;
  }

  let className = 'xlate-none';
  const hours = Math.floor(durationMinutes / 60);

  if (hours >= 12) {
    // "Multi-day" can be translated while "4 h 38 m" cannot
    className = null;
  }

  const estimateText = isEstimate ? `${StringConstantsMixin.strings.FILTERS.EST} ` : '';

  return (
    <>
      <span>&nbsp;•&nbsp;</span>
      <span className={className}>{estimateText}{MapStatsUtil.minutesToFormattedTime(durationMinutes)}</span>
    </>
  );
};

export default CardDuration;
